import React, {useEffect, useState} from 'react';
import {Button, Cascader, Form, Input, Layout, message, Modal, Select} from "antd";
import Cookie from "js-cookie";


const Useradmin_ui = () => {
    const [open_modal_item1, setopen_modal_item1] = useState(false);
    const [cancel_modal_item1, setcancel_modal_item] = useState(false);

    const click_modal_item1_cancel = (e: any) => {
        setopen_modal_item1(false)


    }

    const [form_botton_loading, setform_botton_loading] = useState(false);
    const [return_finish_data, setreturn_finish_data] = useState('');

    const [form_finish, setform_finish] = useState('');


        const data_body = new FormData();
    data_body.append('form', JSON.stringify(form_finish))
    data_body.append('usertoken', String(Cookie.get('userToken')));


    useEffect(() => {
        const data_async = async () => {

            const data_await = await fetch('https://chatv2.leytcn.com/api/register/index.php', {
                method: 'POST',
                body: data_body
            });

            const return_data = await data_await.json();
            setreturn_finish_data(return_data);

            if (return_data.msg === 'success') {

                setform_botton_loading(false)

                message.success('添加用户成功')


                setopen_modal_item1(false);

            } else if (return_data.msg === 'error') {

                message.error('用户添加失败')

                setform_botton_loading(false)
            }


        }


        if (form_finish !== '') {
            data_async();

            setform_botton_loading(true)

        }


    }, [form_finish]);


    const select_data: any = [

        {title: '管理员', value: '管理员'},

        {title: '用户', value: '用户'},


    ]


    const select_item2_data: any = [

        {
            title: '主管部门', value: '主管部门',

        }
        ,
        {

            title: '技术部门', value: '技术部门'


        }

        , {

            title: '客服部门', value: '客服部门'

        }, {


            title: '人事部门', value: '人事部门'
        }

    ]
    const model_item1_finish = (e: any) => {

        console.log(e)
        setform_finish(e);
    }

    return (<Layout>

        <div>

            <h1>管理员界面</h1>

            <Button onClick={() => setopen_modal_item1(true)}>添加用户</Button>
            <Modal footer={null} open={open_modal_item1} onCancel={click_modal_item1_cancel} title={'添加用户'}>

                <Form name={'model_item1_add_user'} onFinish={model_item1_finish}>

                    <label>用户名</label>
                    <Form.Item name={'user_name'} rules={[{required: true, message: '请输入用户名'}]}>

                        <Input>


                        </Input>

                    </Form.Item>
                    <label>密码</label>
                    <Form.Item name={'user_password'} rules={[{required: true, message: '请输入密码'}]}>

                        <Input key={'password'} type={'password'}>


                        </Input>


                    </Form.Item>

<label>管理权限</label>
                    <Form.Item name={'select_form_item1'} rules={[{required: true, message: 'Please input!'}]}>

                        <Select options={select_data}>

                        </Select>

                    </Form.Item>


                    <label>部门</label>

                    <Form.Item name={'select_form_item2'} rules={[{required:true,message: '请输入内容'}]}>

                        <Select options={select_item2_data}>
                        </Select>

                    </Form.Item>

                    <Button loading={form_botton_loading} htmlType={'submit'} type={'primary'}>添加</Button>

                    <Button onClick={() => setopen_modal_item1(false)}>取消</Button>

                </Form>


            </Modal>
        </div>


    </Layout>)

}


export default Useradmin_ui;